import { IInputStep } from 'interfaces/IInputStep';

/**
 * Exchanges the positions of two steps within a task's `steps` array,
 * returning a new array and leaving every other element where it was.
 *
 * Position carries meaning here — it is the order products are mixed in the
 * tank on farm — and `InputStep` deliberately carries no `sort` attribute, so
 * array position *is* the order (see OP-2123 for why that is by design).
 *
 * Swapping rather than splicing is deliberate too: it keeps every element that
 * was not named exactly where it sat, which is what lets a re-order stay
 * predictable while a category filter is hiding some of a task's steps.
 *
 * Returns `null` when the swap would be meaningless — either id is absent, or
 * both name the same step — so callers can treat that as a no-op without
 * having to diff arrays.
 */
export const swapStepsById = (
  steps: IInputStep[],
  aId: string,
  bId: string
): IInputStep[] | null => {
  const aIndex = steps.findIndex((step) => step.stepId === aId);
  const bIndex = steps.findIndex((step) => step.stepId === bId);

  if (aIndex === -1 || bIndex === -1 || aIndex === bIndex) return null;

  const next = [...steps];
  [next[aIndex], next[bIndex]] = [next[bIndex], next[aIndex]];
  return next;
};

export default swapStepsById;
